// @flow
import PlainFile from './PlainFile';
import FilesPreview from './FilesPreview';

export default PlainFile;
export { FilesPreview };
